<div class="col-12 d-flex mt-4 p-0 totalDiv">
  <div class="col-9">
        <mat-card class="w-100 h-100">
          <div class="col-12 p-0 position-relative h-100">
            <h3 *ngIf="cp_business.name">{{cp_business.name}}</h3>
            <div class="scrollCommentSection">
              <div class="no-msg" *ngIf="!cp_business.name">Please select a business to send a message <img src="../../../assets/images/right-arrow.png"></div>
              <div class="chatHistory">
                <div *ngFor='let item of messages, let i = index'>
                  <div class="date-container mb-2" *ngIf="i==0 || getDate(item.created) != getDate(messages[i-1].created)"><div class="date-gray">{{item.created | date : "MMM dd, yyyy"}}</div></div>
                  <div class="chat_flex pastChat mb-2">
                    <div class="propic_container">
                      <div class='dpCnr _comment' [ngStyle]="{'background-image':'url(' + profile_images[item.createdby] +')' }"></div>
                    </div>
                    <div class="chatDetails">
                      <div class="pastChatContainer ">
                        <div class="name" title="{{item.created | date : 'MMM dd, yyyy, hh:mm a'}}"> {{item.um_user_name}}
                          <span *ngIf="item.um_user_is_stdc_user === 'Y'"> (Admin)</span>
                          <span class="time-gray">{{item.created | date : "hh:mm a"}}</span>
                        </div>
                        <div class="d-flex align-items-center">
                          <div class="mr-1"><img src="assets/images/comment.svg" alt=""> </div>
                          <div class="toAddress">{{item.sender_bp_business_name}} </div>
                        </div>

                      </div>
                      <div class="w-100 chatMessge">
                        <pre *ngIf="item.read_by_user_name && item.read_at_time" title="{{item.read_by_user_name}} read the message on {{item.read_at_time | date : 'MMM dd, yyyy, hh:mm:ss a'}}">{{item.message}}</pre>
                        <pre *ngIf="!item.read_by_user_name || !item.read_at_time">{{item.message}}</pre>
                      </div>
                      <div class="d-flex" *ngIf='item["bp_message_attachments"]'>
                        <div class="ml-1 mb-1 pointer" *ngFor="let element of item['bp_message_attachments']; let i = index" (click)='downLoad(element)'>
                          <div class="downloadContainer d-flex">
                            <div class="text-center attachClip">
                              <img src="assets/images/boldclip.png" class="pointer" alt="">
                            </div>
                            <div class="ChatAttachName" title="{{element.attachment_name}}">
                              <p>{{element.attachment_name}}</p>
                            </div>
                          </div>
                        </div>
                      </div>
  
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="absolute_text_input">
              <div class="chatTextinput pb-30">
                <mat-label *ngIf='aboutBusiness!=="All"' class="titleColor">Message {{aboutBusiness}} about {{selected_business}}</mat-label>
                <!-- <mat-label *ngIf='aboutBusiness==="All"' class="titleColor">Broadcasting is currently not available</mat-label> -->
                <textarea matInput class="pb-2 chatInputArea mt-1" [readonly]="addButton" [(ngModel)]='newMessage' rows="2" matInput (keyup.enter)="addComment()"></textarea>
                <!-- <div class="d-flex text-right align-items-center">
                  <div class='file_image chatAttach d-flex align-items-center'>
                    <div class="attachCover">
                      <img src="assets/images/boldclip.png" class="pointer" alt="">
                      <input type="file" (change)='addFileComment($event)' multiple>
                    </div>
                  </div>
                </div> -->
                <div class="d-flex spacebtw">
                  <div class="d-flex width-file">
                    <div class="commentsAttach commentAttachPos" *ngFor='let item of AttachFiles; let j = index'>
                      <p class="long_text_container" title="{{item.name}}">{{item.name}}</p>
                      <div (click)='removeAttach(j)' class="miniClose">x</div>
                    </div>
                  </div>
                  <div class="attachCover">
                    <!-- <img   matTooltipClass="matToolTipCmmnt" class="txttooltip"
                     [title]="tooltip"  src="/assets/images/i.svg"> &nbsp;&nbsp; -->
                    <img src="assets/images/boldclip.png" class="pointer" alt="">
                    <input #attachInput type="file" (change)='addFileComment($event)' multiple>
                  </div>
                  <button mat-raised-button color="primaryCus" [disabled] ="newMessage==''" (click)="addComment()" class="text-center send-btn"></button>
                </div>
              </div>
              <div class="col-12 p-0 mt-2">
                <div>
                  <span class="doc_add_validation">{{supporetsFiles}}</span>
                  <span class="doc_add_validation">{{supportMaxFileSize}}</span>
                </div>
              </div> 
            </div>
          </div>
        </mat-card>
  </div>
  <div class="col-3">
    <mat-card class="h-100">
      <div class="col-12 p-0">

      </div>
      <div class="col-12 p-0 mt-2">
        <form [formGroup]="sharedDoc" class="mt-3">
          <!-- <mat-radio-group formControlName="type" class="radio" (change)="radioButtonSelection($event)">
            <mat-radio-button value="0">All</mat-radio-button>
            <mat-radio-button value="1">Financial Institutions</mat-radio-button>
          </mat-radio-group> -->
          <mat-select class="type-select mt-2" formControlName="type" (selectionChange)="radioButtonSelection($event)">
            <mat-option value='0'>All</mat-option>
            <mat-option value='fin'>Financial Institutions</mat-option>
            <mat-option value='non_fin'>Non Financial Institutions</mat-option>
          </mat-select>
          <mat-form-field class="col-12 mt-2 p-rela"> 
            <input type="text" placeholder="Search business" #searchBox matInput [matAutocomplete]="businessInput1"
            formControlName="business" (keyup)="shareBizValue($event)">
             <mat-autocomplete autoActiveFirstOption #businessInput1="matAutocomplete" (optionSelected)='selectShareBusiness($event)'>
               <ng-container *ngIf="isLoading">
                <mat-option>
                  <div class="circle_container container_inner_load">
                    Loading
                    <div class="circle"></div>
                    <div class="circle"></div>
                    <div class="circle"></div>
                    <div class="circle"></div>
                    <div class="circle"></div>
                    <div class="circle"></div>
                  </div>
                </mat-option>
              </ng-container>
              <ng-container *ngIf="!isLoading">
                <mat-option *ngFor="let item of bussinessList" [value]="item">
                  <div class="symbol" >
                     <img *ngIf="item.is_cannabis_business == 'Y'" class="dropImage" src="../../../../../assets/images/cannabis.png">
                     <img *ngIf="item.bp_group_shortcode == 'STANC'" class="dropImage" src="/assets/images/logo.png">
                    <mat-icon class="matIcon" *ngIf="item.bp_group_shortcode == 'MEMFI'" class="matIcon"  >account_balance</mat-icon>
                  </div>

                 <!-- <span *ngIf="item.is_group">
                  <img class="dropImage2" src="../../../../../assets/images/group.png">
               </span> -->
                 {{item.name}}
                </mat-option>
              </ng-container>
            </mat-autocomplete>
            <div class="close-btn" *ngIf="sharedDoc.value.business" (click)="clearSearch()"></div>
          </mat-form-field>
        </form>
      </div>
      <div class="searchResults">
           <div class="col-12 p-0 mb-2 list-item" *ngFor="let item of listBiz" (click)="selectBusiness(item)" [ngClass]="{'active':cp_business.bp_business_id==item.cp_bp_business_id}">
          <div class="pastChatContainer businessPad p-rela">
            <div class="name"> {{item.cp_bp_business_name}}</div>
            <div class="time"> {{item.last_created | date:'MMM dd, yyyy, hh:mm a'}} </div>
          <div class="count" *ngIf="item.count>0">{{item.count}}</div>
        </div>
      </div>
      <div class="more" *ngIf="listBizTotal!=listBiz.length" (click)="loadmore()">Load more</div>
     </div>
    </mat-card>
  </div>
</div>
